export default function SearchBarIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path d="m15.882 15.312-3.442-3.442c1.1267-1.2612 1.8124-2.923 1.8124-4.7436 0-3.9287-3.1973-7.126-7.126-7.126-3.9287 0-7.126 3.1973-7.126 7.126 0 3.9288 3.1973 7.126 7.126 7.126 1.8205 0 3.4824-0.6857 4.7436-1.8124l3.442 3.442c0.078 0.078 0.1829 0.1183 0.285 0.1183 0.1022 0 0.2071-0.0403 0.2851-0.1183 0.1586-0.1587 0.1586-0.4141 0-0.5701zm-8.7556-1.8662c-3.485 0-6.3193-2.8343-6.3193-6.3194 0-3.485 2.8343-6.3193 6.3193-6.3193 3.485 0 6.3194 2.8343 6.3194 6.3193 0 3.485-2.8343 6.3194-6.3194 6.3194z"/>
      </svg>
    </>
  );
}